import { env } from '@/env';

/**
 * Map region IDs to human-readable labels
 */
const REGION_LABELS: Record<string, string> = {
  'eastus': 'East US',
  'westus': 'West US',
  'canadacentral': 'Canada Central',
  'uksouth': 'UK South',
  'northeurope': 'North Europe',
};

/**
 * Get all available ETL regions from environment configuration
 */
export function getAvailableRegions(): string[] {
  return env.VITE_ETL_REGIONS;
}

/**
 * Get human-readable label for a region ID
 */
export function getRegionLabel(regionId: string): string {
  return REGION_LABELS[regionId] || regionId;
}

/**
 * Get the static NAT gateway IP address for a region
 */
export function getRegionNatIp(regionId: string): string | undefined {
  return env.VITE_ETL_NAT_IPS[regionId];
}
